import {useMutation} from '@tanstack/react-query';
import {resourcesFlagsCreate} from 'api/v2';
import type {ResourceFlagCreateRequest} from 'api/v2';
import {useStores} from 'hooks/useStores';

export type FlagResourceVariables = ResourceFlagCreateRequest & {
  resourceId: string;
};

// The API allows one active flag per resource and returns
// 400 {resource: [...]} when someone else flagged it first.
export const isAlreadyFlaggedError = (error: unknown): boolean => {
  type Body = {resource?: unknown};
  const maybe = error as {
    status?: number;
    data?: Body;
    response?: {status?: number; data?: Body};
  };
  const status = maybe?.status ?? maybe?.response?.status;
  const body = maybe?.response?.data ?? maybe?.data;
  return status === 400 && Boolean(body?.resource);
};

export const useFlagResource = () => {
  const {resourceStoreV2} = useStores();

  return useMutation({
    mutationFn: ({resourceId, ...flag}: FlagResourceVariables) =>
      resourcesFlagsCreate(resourceId, flag),
    onSuccess: (_response, {resourceId}) => {
      resourceStoreV2.markResourceFlagged(resourceId);
    },
    onError: (error, {resourceId}) => {
      if (isAlreadyFlaggedError(error)) {
        resourceStoreV2.markResourceFlagged(resourceId);
      }
    },
  });
};
